import { SYSTEM_MODAL_SHOW, SYSTEM_MODAL_DISMISS } from './';

export const types = {
  SYSTEM_MODAL_SHOW: 'app/systemModal/SYSTEM_MODAL_SHOW',
  SYSTEM_MODAL_DISMISS: 'app/systemModal/SYSTEM_MODAL_DISMISS',
  LOCAL_MODAL_DISMISS: 'app/systemModal/LOCAL_MODAL_SHOW',
  LOCAL_MODAL_SHOW: 'app/systemModal/LOCAL_MODAL_DISMISS',
};

export const show = (content, options) => ({
  type: types.SYSTEM_MODAL_SHOW,
  payload: {
    content,
    isClosedOutside: options.isClosedOutside || false,
    onDismiss: options.onDismiss,
    blurClassName: options.blurSize || 'global-darkSmallBlur',
    onlyOverlay: options.onlyOverlay || false,
  },
});

export const dismiss = () => ({
  type: types.SYSTEM_MODAL_DISMISS,
  payload: {},
});

export const showLocalModal = () => ({
  type: types.LOCAL_MODAL_SHOW,
  payload: {
    localModalEnabled: true,
    blurClassName: 'global-darkSmallBlur',
    onlyOverlay: false,
  },
});

export const dismissLocalModal = () => ({
  type: types.LOCAL_MODAL_DISMISS,
  payload: {
    localModalEnabled: false,
    blurClassName: 'global-darkSmallBlur',
    onlyOverlay: false,
  },
});

export const showLightboxModal = (content, options) => {
  return show(content, {
    blurClassName: 'global-darkBigBlur',
    onlyOverlay: true,
    ...options,
  })
};
